import {ColumnBar as ColumnBarSrc, Part} from './ColumnBar'

export const ColumnBar = Object.assign(ColumnBarSrc, {Part});
